import pdfmake from "pdfmake/build/pdfmake";
import vfs_fonts from "pdfmake/build/vfs_fonts";
import { FechaHoy, FechaHoyMesPosterior, NombreMes, CreateFecha } from "../../../../../../shared/utils/fecha";
import { toDecimalString } from "../../../../../../shared/utils/numbers";
import logoPdf from "./logo.png";
import { getDynamicColumns_DetalleCentroCosto, getDynamicColumns_DetalleEmpleado, hayFiniquito, hayPrimas, haySSEmpleado } from "./functions";

const toDataUrl = async(file,callback) =>{
  var xhr = new XMLHttpRequest();
     xhr.responseType = 'blob';
     xhr.onload = function() {
    var reader = new FileReader();
    reader.onloadend = function() {
     callback(reader.result);
  }
    reader.readAsDataURL(xhr.response);
 };
  xhr.open('GET', file);
  xhr.send();
}

let logo;

toDataUrl(logoPdf,(base64Image)=> {logo=base64Image})

const fechaFacturacion = (fechaFacturacion) => fechaFacturacion===null?FechaHoy():CreateFecha(fechaFacturacion);
const FechaVencimiento = (fecha,fechaFacturacion) => fecha === null ? FechaHoyMesPosterior(fechaFacturacion) : CreateFecha(fecha);

function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export const CreatePDFSucursal = (data, tipo, esAdm, download,translate) => {
  console.log('createPDF ', data);
  let DOCUMENT = prepareDocument(data,tipo,esAdm,translate);

  pdfmake.vfs = vfs_fonts.pdfMake.vfs;
  download === true ? pdfmake.createPdf(DOCUMENT).download(`${data[0].informe.total.idFactura}.pdf`) : pdfmake.createPdf(DOCUMENT).open();
};

//CABECERA
const generateDoubleCell = (field,value,props)=>{
  return {columns:[{width:'auto',text:field,bold:true,color:'#004f86'},{width:'*',text:value,margin:[2,0]}],fillColor:'#DBD7D2',fontSize:7,...props}
}

const getDataFacturacionHeader = (dataHeader,translate) => [
  [generateDoubleCell(`${translate('codigo-cliente')}:`,dataHeader.idEmpresa),
  generateDoubleCell(`${translate('referencia')}:`,dataHeader.referencia),
  generateDoubleCell(`${translate('fecha')}:`,fechaFacturacion(dataHeader.fechaFacturacion)),
  generateDoubleCell(`${translate('nFactura')}:`,dataHeader.idFactura!==null?dataHeader.idFactura:''),
  generateDoubleCell('C:','')
  ],
  [generateDoubleCell(`${translate('proyecto')}:`,'',{colSpan:5})],
  [
    generateDoubleCell('C.I.F.:',dataHeader.cif!==null?dataHeader.cif:''),
    generateDoubleCell(`${translate('razon-social')}:`,dataHeader.empresa,{colSpan:4}),{},{},{},
    //generateDoubleCell('Dirección:','Av. Pte. Roque Sáenz Peña 616 2P 1035AAO CABA ARGENTINA',{colSpan:3}),{},{}
  ],
  [
    generateDoubleCell(`${translate('direccion')}:`,dataHeader.domicilioFiscal!==null?dataHeader.domicilioFiscal:'',{colSpan:5})
  ]
  // [
  //   generateDoubleCell('C.I.F.:','30645212572'),
  //   generateDoubleCell('Domicilio Fiscal:','Av. Pte. Roque Sáenz Peña 616 2P 1035AAO CABA ARGENTINA',{colSpan:4}),{},{},{}
  // ]
]

const getDatosEmpresa = (data,translate) => [
  {
    table: {
      headerRows: 1,
      widths: ["*",'*','auto','*','auto'],
      body: [[{text:translate('datos-facturacion').toUpperCase(), style:'subHeaderTitle', colSpan:5},{},{},{},{}],...getDataFacturacionHeader(data,translate)]
    },
    layout:{
      vLineWidth: function (i, node) {
        return i===0  || i===node.table.widths.length ?  1 : 2;
      },
      hLineWidth: function (i, node) {
        return i>0 ? 1 : 0;
      },
      vLineColor: function (i, node) {
        return i===0  || i===node.table.widths.length ?  "#004f86" : '#B9B8B7';
      },
      hLineColor: function (i, node) {
        return i===node.table.body.length ?  "#004f86" : '#B9B8B7';
    },
    }
  }
]

const getHeader =[
  {text:'Rodriguez Arias 28-30\n48011 Bilbao\nwww.elecnor.es',style:'headerAddress'}
]


//DETALLE CENTRO COSTO DESTINO
const cabeceraTablaDetalle_CentroCosto_1 = (verPrimas,verFiniquito,translate) => {
  var result = [
    {text:''},{text:''},
    { text: translate('ajuste-ecualizacion-fiscal'), style:"topHeaderPage2", alignment: "center", colSpan:2},
    {},{text:''},{text:''},{text:''},{text:''},{text:''}
  ]

  if(verPrimas===true){result.splice(2, 0, {text:''});}
  if(verFiniquito===true){result.splice(2, 0, {text:''});}

  return result;
}

const cabeceraTablaDetalle_CentroCosto_2 = (verPrimas,verFiniquito,translate) => {
  var result = [
  {text:'',alignment: "left" },
  { text: translate('salario'), style:"headerPage2", alignment: "right" },
  { text: translate('retencion-especial-acotado'), style:"headerPage2", alignment: "right" },
  { text: translate('retencion-especial-irpf-acotado'), style:"headerPage2", alignment: "right" },
  { text: translate('seguridad-social-empleado'), style:"headerPage2", alignment: "right" },
  { text: translate('salario-neto'), style:"headerPage2", alignment: "right" },
  { text: translate('salario-neto-facturable-acotado'), style:"headerPage2", alignment: "right" },
  { text: translate('seguridad-social-empresa'), style:"headerPage2", alignment: "right"},
  { text: translate('total-factura'), style:"headerPage2", alignment: "right", margin:[0,0,2,0]}
  ]

  if(verPrimas===true){result.splice(2, 0, { text: translate('prima'), style:"headerPage2", alignment: "right" });}
  if(verFiniquito===true){result.splice(2, 0, { text: translate('finiquito'), style:"headerPage2", alignment: "right" });}

  return result;
}

const datosTablaDetalleCentroCosto = (dataDetalle,verPrimas,verFiniquito) =>
  dataDetalle.map((d)=>{
    var result =[{text:d.centroCostoDestino},
      {text:toDecimalString(d.salario,2), style:'decimal'},{text:toDecimalString(d.ret_Hipot,2),style:'decimal'},{text:toDecimalString(d.irpf,2),style:'decimal'},
      {text:toDecimalString(d.ss_Empleado),style:'decimal'},{text:toDecimalString(d.salarioNeto),style:'decimal'},{text:toDecimalString(d.salarioNetoFacturable),style:'decimal'},
      {text:toDecimalString(d.costo_ss,2),style:'decimal'},{text:toDecimalString(d.totalFacturaPagar,2),style:'decimal', margin:[0,0,2,0]}
    ]

    if(verPrimas===true){result.splice(2, 0, {text:toDecimalString(d.prima,2), style:'decimal'});}
    if(verFiniquito===true){result.splice(2, 0, {text:toDecimalString(d.finiquito,2), style:'decimal'});}

    return result;
  });

const totalTablaDetalleCentroCosto = (dataTotal,verPrimas,verFiniquito)=> {
  var result =[{text:''},
  {text:toDecimalString(dataTotal.salario,2), style:['decimal','totalCell'],bold:true},
  {text:toDecimalString(dataTotal.ret_Hipot,2),style:['decimal','totalCell'],bold:true},
  {text:toDecimalString(dataTotal.irpf,2),style:['decimal','totalCell'],bold:true},
  {text:toDecimalString(dataTotal.ss_Empleado,2),style:['decimal','totalCell'],bold:true},
  {text:toDecimalString(dataTotal.salarioNeto,2),style:['decimal','totalCell'],bold:true},
  {text:toDecimalString(dataTotal.salarioNetoFacturable,2),style:['decimal','totalCell'],bold:true},
  {text:toDecimalString(dataTotal.costo_ss,2),style:['decimal','totalCell'],bold:true},
  {text:toDecimalString(dataTotal.totalFacturaPagar,2),style:['decimal','totalCell'],margin:[0,0,2,0],bold:true}
  ]

  if(verPrimas===true){result.splice(2, 0, {text:toDecimalString(dataTotal.prima,2), style:['decimal','totalCell'],bold:true});}
  if(verFiniquito===true){result.splice(2, 0, {text:toDecimalString(dataTotal.finiquito,2), style:['decimal','totalCell'],bold:true});}

  return result;
}

const getDetalleCentroCosto = (data,createBreak,translate) => {
  const verPrimas = hayPrimas(data.detalleCentroCosto);
  const verFiniquito = hayFiniquito(data.detalleCentroCosto);
  const esSucursal = true;

  return [
    {
      table: {
        headerRows: 2,
        widths: getDynamicColumns_DetalleCentroCosto(verPrimas,verFiniquito,esSucursal),
        body: [cabeceraTablaDetalle_CentroCosto_1(verPrimas,verFiniquito,translate),cabeceraTablaDetalle_CentroCosto_2(verPrimas,verFiniquito,translate),
          ...datosTablaDetalleCentroCosto(data.detalleCentroCosto,verPrimas,verFiniquito),
          totalTablaDetalleCentroCosto(data.total,verPrimas,verFiniquito)
        ]
      },
      layout:'noBorders',
      pageBreak: createBreak === true ? 'after' : ''
    }
  ]
}


// const cabeceraTablaDetalle_CentroCosto_1 = (verPrimas,verFiniquito,translate) => {
//   var result = [
//     {text:''},{text:''},
//     { text: translate('ajuste-ecualizacion-fiscal'), style:"topHeaderPage2", alignment: "center", colSpan:2},
//     {},{text:''},{text:''},{text:''}
//   ]

//   if(verPrimas===true){result.splice(2, 0, {text:''});}
//   if(verFiniquito===true){result.splice(2, 0, {text:''});}

//   return result;
// }

// const cabeceraTablaDetalle_CentroCosto_2 = (verPrimas,verFiniquito,translate) => {
//   var result = [
//   {text:'',alignment: "left" },
//   { text: translate('salario'), style:"headerPage2", alignment: "right" },
//   { text: translate('retencion-especial-acotado'), style:"headerPage2", alignment: "right" },
//   { text: translate('retencion-especial-irpf-acotado'), style:"headerPage2", alignment: "right" },
//   { text: translate('salario-neto-facturable-acotado'), style:"headerPage2", alignment: "right" },
//   { text: translate('seguridad-social-empresa'), style:"headerPage2", alignment: "right"},
//   { text: translate('total-factura'), style:"headerPage2", alignment: "right", margin:[0,0,2,0]}
//   ]

//   if(verPrimas===true){result.splice(2, 0, { text: translate('prima'), style:"headerPage2", alignment: "right" });}
//   if(verFiniquito===true){result.splice(2, 0, { text: translate('finiquito'), style:"headerPage2", alignment: "right" });}

//   return result;
// }

// const datosTablaDetalleCentroCosto = (dataDetalle,verPrimas,verFiniquito) =>
//   dataDetalle.map((d)=>{
//     var result =[{text:d.centroCostoDestino},
//       {text:toDecimalString(d.salario,2), style:'decimal'},{text:toDecimalString(d.ret_Hipot,2),style:'decimal'},{text:toDecimalString(d.irpf,2),style:'decimal'},
//       {text:toDecimalString(d.salarioNetoFacturable),style:'decimal'},{text:toDecimalString(d.costo_ss,2),style:'decimal'},{text:toDecimalString(d.totalFacturaPagar,2),style:'decimal', margin:[0,0,2,0]}
//     ]

//     if(verPrimas===true){result.splice(2, 0, {text:toDecimalString(d.prima,2), style:'decimal'});}
//     if(verFiniquito===true){result.splice(2, 0, {text:toDecimalString(d.finiquito,2), style:'decimal'});}

//     return result;
//   });

// const totalTablaDetalleCentroCosto = (dataTotal,verPrimas,verFiniquito)=> {
//   var result =[{text:''},
//   {text:toDecimalString(dataTotal.salario,2), style:['decimal','totalCell'],bold:true},
//   {text:toDecimalString(dataTotal.ret_Hipot,2),style:['decimal','totalCell'],bold:true},
//   {text:toDecimalString(dataTotal.irpf,2),style:['decimal','totalCell'],bold:true},
//   {text:toDecimalString(dataTotal.salarioNetoFacturable,2),style:['decimal','totalCell'],bold:true},
//   {text:toDecimalString(dataTotal.costo_ss,2),style:['decimal','totalCell'],bold:true},
//   {text:toDecimalString(dataTotal.totalFacturaPagar,2),style:['decimal','totalCell'],margin:[0,0,2,0],bold:true}
//   ]

//   if(verPrimas===true){result.splice(2, 0, {text:toDecimalString(dataTotal.prima,2), style:['decimal','totalCell'],bold:true});}
//   if(verFiniquito===true){result.splice(2, 0, {text:toDecimalString(dataTotal.finiquito,2), style:['decimal','totalCell'],bold:true});}

//   return result;
// }

// const getDetalleCentroCosto = (data,createBreak,translate) => {
//   const verPrimas = hayPrimas(data.detalleCentroCosto);
//   const verFiniquito = hayFiniquito(data.detalleCentroCosto);
//   return [
//     {
//       table: {
//         headerRows: 2,
//         widths: getDynamicColumns_DetalleCentroCosto(verPrimas,verFiniquito),
//         body: [cabeceraTablaDetalle_CentroCosto_1(verPrimas,verFiniquito,translate),cabeceraTablaDetalle_CentroCosto_2(verPrimas,verFiniquito,translate),
//           ...datosTablaDetalleCentroCosto(data.detalleCentroCosto,verPrimas,verFiniquito),
//           totalTablaDetalleCentroCosto(data.total,verPrimas,verFiniquito)
//         ]
//       },
//       layout:'noBorders',
//       pageBreak: createBreak === true ? 'after' : ''
//     }
//   ]
// }

//DETALLE POR EMPLEADO
const cabeceraTablaDetalle_1 = (verPrimas,verFiniquito,translate) => {

  var result = [
  {text:''},{text:''},{text:''},
  { text: translate('ajuste-ecualizacion-fiscal'), style:"topHeaderPage2", alignment: "center", colSpan:2},
  {},{text:''},{text:''},{text:''},{text:''},{text:''}
  ]

  if(verPrimas===true){result.splice(3, 0, {text:''});}
  if(verFiniquito===true){result.splice(3, 0, {text:''});}

  return result;
}

const cabeceraTablaDetalle_2 = (verPrimas,verFiniquito,translate) => {

var result =[
  {text:'',alignment: "left" },{text:'',alignment: "left" },
  { text: translate('salario'), style:"headerPage2", alignment: "right" },
  { text: translate('retencion-especial-acotado'), style:"headerPage2", alignment: "right" },
  { text: translate('retencion-especial-irpf-acotado'), style:"headerPage2", alignment: "right" },
  { text: translate('seguridad-social-empleado'), style:"headerPage2", alignment: "right" },
  { text: translate('salario-neto'), style:"headerPage2", alignment: "right" },
  { text: translate('salario-neto-facturable-acotado'), style:"headerPage2", alignment: "right" },
  { text: translate('seguridad-social-empresa'), style:"headerPage2", alignment: "right"},
  { text: translate('total-factura'), style:"headerPage2", alignment: "right", margin:[0,0,2,0]}
]
 
if(verPrimas===true){result.splice(3, 0, { text: translate('prima'), style:"headerPage2", alignment: "right" });}
if(verFiniquito===true){result.splice(3, 0, { text: translate('finiquito'), style:"headerPage2", alignment: "right" });}

return result;
}

const datosTablaDetalle = (dataDetalle,verPrimas,verFiniquito) =>{

  return dataDetalle.map((d)=>{
    var result = [{text:d.dni,style:'textoDetalle'},{text:d.nombre,style:'textoDetalle'},
    {text:toDecimalString(d.salario,2), style:'decimal'},
    {text:toDecimalString(d.ret_Hipot,2),style:'decimal'},{text:toDecimalString(d.irpf,2),style:'decimal'},
    {text:toDecimalString(d.ss_Empleado,2), style:'decimal'},
    {text:toDecimalString(d.salarioNeto,2), style:'decimal'},
    {text:toDecimalString(d.salarioNetoFacturable),style:'decimal'},{text:toDecimalString(d.costo_ss,2),style:'decimal'},
    {text:toDecimalString(d.totalFacturaPagar,2),style:'decimal', margin:[0,0,2,0]}
    ]

    if(verPrimas===true){result.splice(3, 0, {text:toDecimalString(d.prima,2), style:'decimal'});}
    if(verFiniquito===true){result.splice(3, 0, {text:toDecimalString(d.finiquito,2), style:'decimal'});}

    return result;
  })};

const totalTablaDetalle = (dataTotal,verPrimas,verFiniquito)=> {

var result = [{text:''},{text:''},
{text:toDecimalString(dataTotal.salario,2), style:['decimal','totalCell'],bold:true},
{text:toDecimalString(dataTotal.ret_Hipot,2),style:['decimal','totalCell'],bold:true},
{text:toDecimalString(dataTotal.irpf,2),style:['decimal','totalCell'],bold:true},
{text:toDecimalString(dataTotal.ss_Empleado,2),style:['decimal','totalCell'],bold:true},
{text:toDecimalString(dataTotal.salarioNeto,2),style:['decimal','totalCell'],bold:true},
{text:toDecimalString(dataTotal.salarioNetoFacturable,2),style:['decimal','totalCell'],bold:true},
{text:toDecimalString(dataTotal.costo_ss,2),style:['decimal','totalCell'],bold:true},
{text:toDecimalString(dataTotal.totalFacturaPagar,2),style:['decimal','totalCell'],margin:[0,0,2,0],bold:true}
]

if(verPrimas===true){result.splice(3, 0, {text:toDecimalString(dataTotal.prima,2), style:['decimal','totalCell'],bold:true});}
if(verFiniquito===true){result.splice(3, 0, {text:toDecimalString(dataTotal.finiquito,2), style:['decimal','totalCell'],bold:true});}

return result;
}

const getDetalle = (data,translate) => {
  const verPrimas = hayPrimas(data.detalle);
  const verFiniquito = hayFiniquito(data.detalle);
  const tipoEmpresa = {tipo:data.total.tipoEmpresa, subTipo:data.total.subTipoEmpresa};

  return [
    {
      table: {
        headerRows: 2,
        widths: getDynamicColumns_DetalleEmpleado(verPrimas,verFiniquito,tipoEmpresa),
        body: [cabeceraTablaDetalle_1(verPrimas,verFiniquito,translate),cabeceraTablaDetalle_2(verPrimas,verFiniquito,translate),
          ...datosTablaDetalle(data.detalle,verPrimas,verFiniquito),totalTablaDetalle(data.total,verPrimas,verFiniquito)]
      },
      layout:'noBorders',
      pageBreak: 'after'
    }
  ]
}

//Datos totalizado
const Conceptos_totalizado = (anio,mes,translate) =>{
  return {
  Concepto1: [{text: `${translate('msg-factura-reembolso-costos')} ${capitalizeFirstLetter(mes)} ${anio}`, colSpan:5,style: "tituloConcepto"}],
  Concepto2: [{text: translate('msg-factura-ajuste-salarial'), colSpan:5,style: "tituloConcepto"}]
  }
}

const Costos_totalizado_1 = (configuracion,dataTotalizado,translate) => {

  const _codigoCostoSalarial = configuracion.codigoCostoSalarial;//CodigosConceptos[dataTotalizado.tipoEmpresa].Facturacion;

  return [
    [{text:`- ${translate('costo-salarial')}`,margin:[5,0]},
    {},{},
    {text:'', alignment: "right"},
    {text:_codigoCostoSalarial, alignment: "right",margin:[2,0]}
    ],
    [{text:`- ${translate('salario')}`,margin:[20,0]},
    {},{},
    {text:toDecimalString(dataTotalizado.salario), alignment: "right"},
    {}
    ],
    [{text:`- ${translate('finiquito')}`,margin:[20,0]},
    {},{},
    {text:toDecimalString(dataTotalizado.finiquito), alignment: "right"},
    {}
    ],
    [{text:`- ${translate('indemnizacion')}`,margin:[20,0]},
    {},{},
    {text:toDecimalString(dataTotalizado.indemnizacion), alignment: "right"},
    {}
    ],
    [{text:`- ${translate('prima')}`,margin:[20,0]},
    {},{},
    {text:toDecimalString(dataTotalizado.prima), alignment: "right"},
    {}
    ],
    [{text:`- ${translate('seguridad-social')}`,margin:[5,1]},
    {},{},
    {text:toDecimalString(dataTotalizado.costo_ss), alignment: "right"},
    {}
    ],
    [{text:`- ${translate('total-factura')}`,style:'totalCell',margin:[5,0]},
    {text:'',style:'totalCell'},{text:'',style:'totalCell'},
    {text:`${toDecimalString(dataTotalizado.costoTotal)}€`, alignment: "right",style:'totalCell'},
    {text:'',style:'totalCell'}
    ]
  ]
}

const Costos_totalizado_2 = (configuracion,dataTotalizado,tipo,translate) => {
 
  const totalFacturaPagar = dataTotalizado.totalFacturaPagar;
  const _codigoIrpf = configuracion.codigoIrpf;//CodigosConceptos[dataTotalizado.tipoEmpresa].Irpf;
  const _codigoRetHipot = configuracion.codigoRetHipot;//CodigosConceptos[dataTotalizado.tipoEmpresa].RetencionHipotetica;
  const DataRows = [];

  const TotalRow = [
      {text:translate('total-factura-a-pagar'),style:'totalCell',margin:[5,0],bold:true},
      {text:'',style:'totalCell'},{text:'',style:'totalCell'},
      {text:`${toDecimalString(totalFacturaPagar)}€`, alignment: "right",style:'totalCell',bold:true},
      {text:'',style:'totalCell'}
  ]

  const IrpfRow = (tipo === 1 || (tipo===0 && dataTotalizado.irpf!==0)) ? [
    {text: `(-) ${translate('msg-factura-retencion-irpf-impuesto')}.`,margin:(tipo===0 ? [5,5,5,2] : [5,2])},
    {},{},
    {text:`${toDecimalString(dataTotalizado.irpf)}€`, alignment: "right",margin:(tipo===0 ? [0,5,0,2] : [0,5])},
    {text:`${_codigoIrpf}`, alignment: "right",margin:(tipo===0 ? [0,5,0,2] : [0,5])}
  ] : undefined

  const RetHipotRow = (tipo===0) ? [
    {text: `(-) ${translate('msg-factura-retencion-hipotetica-impuesto')}.`,margin:(IrpfRow!==undefined ? [5,0,5,2] : [5,5])},
    {},{},
    {text:`${toDecimalString(dataTotalizado.ret_Hipot)}€`, alignment: "right",margin:(IrpfRow!==undefined ? [0,0,0,5] : [0,5])},
    {text:`${_codigoRetHipot}`, alignment: "right",margin:(IrpfRow!==undefined ? [0,0,0,5] : [0,5])}
  ] : undefined


  if(IrpfRow!==undefined){DataRows.push(IrpfRow)}
  if(RetHipotRow!==undefined){DataRows.push(RetHipotRow)}

  DataRows.push(TotalRow)

  return DataRows;
}

const getCabeceraTabla_Totalizado = (translate) => [
      { text: translate('concepto'), style: "cabeceraTabla", alignment: "left", margin: [ 5, 0, 0, 0 ] },
      { text: translate('cantidad'), style: "cabeceraTabla", alignment: "center" },
      { text: translate('precio-unidad'), style: "cabeceraTabla", alignment: "right" },
      { text: `${translate('total')}(€)`, style: "cabeceraTabla", alignment: "right" },
      { text: 'C', style: "cabeceraTabla", alignment: "right", margin: [ 0, 0, 5, 0 ]}
];

const getTabla_Totalizado = (configuracion,dataTotalizado,tipo,translate) => {
  const {anio, mes} = dataTotalizado
  const mesStr = NombreMes(mes);

  return [
          {
            table: {
              headerRows: 1,
              widths: ["*", 50, 100, 150, "auto"],
              body: [
                getCabeceraTabla_Totalizado(translate),
                Conceptos_totalizado(anio,mesStr,translate).Concepto1,...Costos_totalizado_1(configuracion,dataTotalizado,translate),
                Conceptos_totalizado(anio,mesStr,translate).Concepto2,...Costos_totalizado_2(configuracion,dataTotalizado,tipo,translate)
              ]
            },
            layout:'noBorders'
            // {
            //   vLineWidth: function (i, node) {
            //       return 0;
            //   },
            //   hLineWidth: function (i, node) {
            //     return i === 8 || i===10 ? 5 : 0;
            //   },
            //   hLineColor: function (i, node) {
            //     return i === 8 || i===10 ? '#ffffff' : '';
            // },
            // }
          }
    ]
}

const detalleTotalizado = (dataTotalizado,translate) => { 
  return {columns: [
  {
    width: '50%',
    stack: [
      {
        columns:[{width:'30%',text: translate('importe-a-pagar'),style:'columnsField'},{width:'70%', text:`${toDecimalString(dataTotalizado.totalFacturaPagar)}€`,style:'columnsValue'}]
      },
      {
        columns:[{width:'30%',text: translate('total-factura'),style:'columnsField'},{width:'70%', text:`${toDecimalString(dataTotalizado.costoTotal)}€`,style:'columnsValue'}]
      },
      {
        columns:[{width:'30%',text:  translate('forma-de-pago'),style:'columnsField'},{width:'70%', text:'R',style:'columnsValue'}]
      },
      {
        columns:[{width:'30%',text:  translate('cuenta-bancaria'),style:'columnsField'},{width:'70%', text:'',style:'columnsValue'}]
      }
    ],
  },
  {
    width: '50%',
    stack: [
      {
        columns:[{width:'30%',text: translate('retencion-pendiente-pago'),style:'columnsField'},{width:'70%', text:'',style:'columnsValue'}]
      },
      {
        columns:[{width:'30%',text: translate('fecha-vencimiento'),style:'columnsField'},{width:'70%', text:FechaVencimiento(dataTotalizado.fechaVencimiento, dataTotalizado.fechaFacturacion),style:'columnsValue'}]
      },
      {
        columns:[{width:'30%',text: translate('fecha-devengo-iva'),style:'columnsField'},{width:'70%', text:'',style:'columnsValue'}]
      }
    ],
  }
]
}}

//Paginas
const pageDetalleCentroCosto = (data,esAdm,createBreak,translate)=>{
  //if(esAdm){
    return(
      getDetalleCentroCosto(data,createBreak,translate)
    )
  //}
}

const pageDetalle = (data,esAdm,translate)=>{
  //if(esAdm){
    return(
      getDetalle(data,translate)
    )
  //}
}

const pageTotal = (configuracion,data,tipo,esAdm,breaked,translate)=>{
  return (esAdm ?
    [
      getTabla_Totalizado(configuracion,data,tipo,translate),
      {text:translate('operacion-nosujeta-al-iva'),margin:[0,25]},
      {canvas: [ { type: 'line', x1: 0, y1: 0, x2: 555, y2: 0, lineWidth: 1, lineColor:'#EE730D'} ], margin:[0,5]},
      {...detalleTotalizado(data,translate),...(esAdm || breaked===true)?{pageBreak: "after"}:{}}
    ]
    :[])
}

const getContent = (data,tipo,esAdm,translate) => {
    const dataLen = data.length-1;
    return data.map((d,index)=> {
        const dataSociedad = {configuracion:d.configuracion,total:d.informe.total,detalle:d.informe.detalle,detalleCentroCosto:d.informe.detalleCentroCosto}
        
        return [
                {text:'',margin:[0,10,0,10]},
                getDatosEmpresa(dataSociedad.total,translate),
                {text:'',margin:[0,10,0,10]},
                ...pageTotal(dataSociedad.configuracion,dataSociedad.total,tipo,esAdm,(index!==dataLen),translate),
                {text:'',margin:[0,10,0,10]},
                 pageDetalle(dataSociedad,esAdm,translate),
                {text:'',margin:[0,10,0,10]},
                 pageDetalleCentroCosto(dataSociedad,esAdm,(index!==dataLen),translate)
              ];
    })
};

const prepareDocument = (data,tipo,esAdm,translate) => {
    return {
      pageSize: 'A4',
      permissions: {
        printing: 'highResolution', //'lowResolution'
        modifying: false,
        copying: false,
        annotating: false,
        fillingForms: false,
        contentAccessibility: true,
        documentAssembly: false
      },
      pageMargins: [10, 40],
      background: [{image:logo,alignment:'right',width:80,height:30,margin: [10, 10, 5, 50]}],
      header: getHeader,
      footer: [{text:'ELECNOR SERVICIOS Y PROYECTOS, S.A.U.- Registro Mercantil de Madrid, Hoja M-5243, Folio 87, Tomo 260, Sección 8ª, Domicilio Social y fiscal: C/Marqués de Mondéjar, 33 - 28028 Madrid NIF/VAT Nº: A79486833',alignment:'center'}],
      content: [...getContent(data,tipo,esAdm,translate)],
      defaultStyle: {
        fontSize: 5
      },
      styles: {
        headerAddress: {margin:[10,10],color: "#004f86"},
        subHeaderTitle:{alignment:'center',fillColor:"#004f86",color:'#ffffff',bold:true,fontSize: 7},
        cabeceraTabla: { fillColor: "#004f86",fontSize: 7, color: "#ffffff", bold: true },
        tituloConcepto: { fillColor:'#EE730D', color: "#ffffff", bold:true,alignment:'left',margin:[2,0]},
        textoDetalle: {fontSize:5},
        columnsField:{color: "#004f86",margin:[0,2]},
        columnsValue:{margin:[0,2]},
        totalCell:{fillColor: "#DFDDDD",color:'#004f86'},
        topHeaderPage2:{fontSize:8,fillColor: "#EE730D",color:'#ffffff',bold:true},
        headerPage2:{fillColor: "#004f86",color:'#ffffff',bold:true},
        decimal:{alignment:'right'}
      },
    };
  };